export default __webpack_public_path__ + "static/media/hotel.0468273d.svg";